import React from 'react';
import { Link } from 'react-router-dom';
import HeadMeta from '../Components/HeadMeta/HeadMeta';
import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';
import './PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {
    return (
        <>
            <HeadMeta
                title="Политика конфиденциальности"
                description="Политика конфиденциальности и обработки персональных данных сайта Locker Wood (lockerwood.ru)."
                keywords="политика конфиденциальности, персональные данные, Locker Wood"
            />
            <Header />
            <div className="breadcrumb breadcrumb--top">
                <a href="/">Главная</a>
                <span>/</span>
                <span style={{ color: "black" }}>Персональные данные</span>
            </div>
            <main className="privacy-policy-main">
                <div className="privacy-policy-container">
                    <h1 className="privacy-policy-title">ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</h1>
                    
                    <div className="privacy-policy-content">
                        <section className="privacy-section">
                            <p>
                                Настоящая Политика конфиденциальности определяет порядок обработки и защиты персональных данных пользователей сайта [указать домен] (далее — «Сайт»), а также порядок получения согласия на их обработку в соответствии с Федеральным законом РФ от 27.07.2006 № 152-ФЗ «О персональных данных» и иными действующими нормативными актами.
                            </p>
                        </section>

                        <section className="privacy-section">
                            <h2>1. Общие положения</h2>
                            <p>
                                1.1. Индивидуальный предприниматель [Ульянов Михаил Владимирович, 500117827607, 325508100120148], являющийся администратором Сайта (далее — «Оператор»), обрабатывает персональные данные пользователей в целях исполнения своих обязательств и предоставления услуг.
                            </p>
                            <p>
                                1.2. Использование Сайта означает согласие пользователя с настоящей Политикой.
                            </p>
                            <p>
                                1.3. В случае несогласия с условиями Политики пользователь обязан прекратить использование Сайта.
                            </p>
                        </section>

                        <section className="privacy-section">
                            <h2>2. Состав обрабатываемых данных</h2>
                            <p>
                                2.1. При использовании Сайта Оператор может собирать и обрабатывать следующие персональные данные:
                            </p>
                            <ul>
                                <li>имя,</li>
                                <li>номер телефона,</li>
                                <li>адрес электронной почты.</li>
                            </ul>
                        </section>

                        <section className="privacy-section">
                            <h2>3. Цели обработки данных</h2>
                            <p>
                                3.1. Персональные данные обрабатываются в целях:
                            </p>
                            <ul>
                                <li>оформления подписки и рассылки информационных сообщений,</li>
                                <li>предоставления консультаций и ответов на запросы пользователей,</li>
                                <li>информирования о продуктах и услугах Оператора,</li>
                                <li>выполнения требований законодательства РФ.</li>
                            </ul>
                        </section>

                        <section className="privacy-section">
                            <h2>4. Способы обработки данных</h2>
                            <p>
                                4.1. Обработка персональных данных осуществляется с использованием средств автоматизации и/или без использования таких средств.
                            </p>
                            <p>
                                4.2. Данные могут использоваться для отправки уведомлений и рассылок через мессенджеры (в том числе Telegram-бот).
                            </p>
                        </section>

                        <section className="privacy-section">
                            <h2>5. Согласие пользователя</h2>
                            <p>
                                5.1. Предоставляя свои персональные данные (имя, телефон, e-mail) и устанавливая отметку («галочку») в поле согласия, пользователь подтверждает согласие на обработку персональных данных в соответствии с настоящей Политикой.
                            </p>
                            <p>
                                5.2. Нажимая кнопку «Получить рассылку» / «Узнать подробнее», пользователь дополнительно выражает согласие на получение информационных и рекламных сообщений от Оператора, в том числе посредством рассылок через мессенджеры (в том числе Telegram-бот).
                            </p>
                            <p>
                                5.3. Согласие действует до момента его отзыва пользователем.
                            </p>
                        </section>

                        <section className="privacy-section">
                            <h2>6. Хранение и защита данных</h2>
                            <p>
                                6.1. Оператор принимает все необходимые организационные и технические меры для защиты персональных данных от неправомерного доступа, изменения, раскрытия или уничтожения.
                            </p>
                            <p>
                                6.2. Данные хранятся не дольше, чем того требуют цели их обработки, если иное не предусмотрено законодательством.
                            </p>
                        </section>

                        <section className="privacy-section">
                            <h2>7. Передача данных третьим лицам</h2>
                            <p>
                                7.1. Оператор не передает персональные данные третьим лицам, за исключением случаев, предусмотренных законодательством РФ.
                            </p>
                        </section>

                        <section className="privacy-section">
                            <h2>8. Права пользователя</h2>
                            <p>
                                8.1. Пользователь имеет право:
                            </p>
                            <ul>
                                <li>получать сведения об обработке его персональных данных,</li>
                                <li>требовать уточнения, блокирования или уничтожения данных, если они являются неполными, устаревшими или обрабатываются незаконно,</li>
                                <li>отозвать согласие на обработку данных путем направления письменного заявления на e-mail: [mishaulyanov89@mail.ru].</li>
                            </ul>
                        </section>

                        <section className="privacy-section">
                            <h2>9. Заключительные положения</h2>
                            <p>
                                9.1. Настоящая Политика конфиденциальности размещена в свободном доступе на Сайте.
                            </p>
                            <p>
                                9.2. Оператор вправе вносить изменения в Политику. Новая редакция вступает в силу с момента публикации на Сайте.
                            </p>
                        </section>

                        <div className="privacy-footer">
                            <p className="privacy-date">
                                Дата последнего обновления: {new Date().toLocaleDateString('ru-RU')}
                            </p>
                            <Link to="/" className="privacy-back-link">
                                ← Вернуться на главную
                            </Link>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;
